import FirestoreDocument from "../../../types/FirestoreDocument";
import FirestoreLifecycle from "../../../types/FirestoreLifecycle";
import { array, boolean, enumValues, intMinMax, record, ref, string } from "../../../types/_types";

import { approval } from "../../approval/types/_types";
import { OrganizationRef } from "../../organizations/types/OrganizationRef";
import { Party } from "../../organizations/types/Party";

import agreementParts from "../constants/agreementParts";
import agreementTypes from "../constants/agreementTypes";

import { AgreementAppendix } from "./AgreementAppendix";
import { AgreementPrice } from "./AgreementPrice";

export const AgreementTemplate = FirestoreDocument.extend({
	appendixes: array(AgreementAppendix),
	approval: approval(),
	canManageAgreements: boolean(false),
	daysToSign: intMinMax(1, 30).default(14),
	firstParty: Party,
	life: intMinMax(1, 9999).default(365),
	name: string(3),
	part: enumValues(agreementParts),
	prices: record(string(), AgreementPrice),
	producer: OrganizationRef,
	type: enumValues(agreementTypes),
}).merge(FirestoreLifecycle);

export const AgreementTemplateRef = ref(AgreementTemplate, {
	name: true,
	part: true,
	type: true,
});
